import { BaseApi } from '../../../api/apiBase';
import type { V1Speaker } from '../../types/speaker.types';

/**
 * API service for individual speaker data using /api/portal endpoints
 */
class SpeakersApi extends BaseApi {
  constructor() {
    super('/api/portal');
  }

  /**
   * Fetch detailed information for a specific speaker
   * Endpoint: GET /api/portal/speakers/:id
   * 
   * @param speakerId - The speaker ID
   * @returns Promise containing detailed speaker information
   */
  async getSpeaker(speakerId: string): Promise<V1Speaker> {
    return this.get<V1Speaker>(`/speakers/${speakerId}`);
  }
}

export const speakersApi = new SpeakersApi();